// Shared inline form styles for views that still build plain inputs (Content Hub, Email composer/editors, Journeys).
// One definition so every section's inputs, labels and cards look the same; built on the theme tokens.
// App-wide control size (2026-10-09): 38px tall, 8px corners, matching the standard buttons.
export const INPUT = {
  width: "100%",
  fontSize: "14px",
  boxSizing: "border-box",
  borderRadius: "8px",
  border: "1px solid var(--plk-border)",
  padding: "9px 11px",
  minHeight: 38,
  fontFamily: "inherit",
  background: "var(--plk-surface)",
  color: "var(--plk-text)"
};
export const SELECT = {
  ...INPUT,
  height: 38,
  padding: "0 9px"
};
export const LABEL = {
  display: "block",
  fontSize: "11px",
  fontWeight: 700,
  letterSpacing: ".04em",
  textTransform: "uppercase",
  color: "var(--plk-text-muted)",
  marginBottom: 4
};
export const FIELD = {
  display: "flex",
  flexDirection: "column",
  gap: 4,
  marginBottom: 10
};
export const CARD = {
  background: "var(--plk-surface)",
  border: "1px solid var(--plk-border-subtle)",
  borderRadius: "var(--plk-radius-md)",
  padding: "12px 14px"
};
export const HINT = {
  fontSize: "12px",
  color: "var(--plk-text-muted)",
  margin: 0
};